module.exports = __webpack_public_path__ + "static/hololive-eaaa00414dbfaa6dc6db323196e8c64c.svg";